import Icon from "@ant-design/icons";
import Space from "antd/lib/space";
import Tag from "antd/lib/tag";
import { FaTrophy } from "react-icons/fa";
import { FaFireFlameCurved } from "react-icons/fa6";
import { sliding, takeUntil } from "../utils/list-utils.ts";
import { useHistory } from "../utils/useHistory.tsx";
import { TooltipElement } from "./TooltipElement.tsx";
import { IconComponentProps } from "@ant-design/icons/lib/components/Icon";

const TWO_DAYS_MILLIS = 1000 * 60 * 60 * 24 * 2;
export const StreakChips = () => {
  const history = useHistory();
  if (!history || history.length === 0) {
    return;
  }
  const today = new Date();
  const utc = new Date(today.getTime() - today.getTimezoneOffset() * 60000);
  const sortedHistory = takeUntil(
    history.sort((a, b) => a.date - b.date),
    (r) => r.date <= utc.getTime(),
  ).reverse();
  const longestStreak =
    sortedHistory.length >= 2
      ? takeUntil(
          sliding(sortedHistory, 2),
          ([a, b]) => Math.abs(a.date - b.date) < TWO_DAYS_MILLIS,
        ).length
      : sortedHistory.length;
  const longestWinningStreak = takeUntil(
    sortedHistory.slice(0, longestStreak),
    (record) => record.success,
  ).length;
  const playedStreakText = `!שיחקת ${longestStreak} ימים בלי להפסיד יום, כל הכבוד`;
  const solvedStreakText = `!פתרת נכונה ${longestWinningStreak} ימים ברצף, עבודה טובה`;
  return (
    <Space
      direction="vertical"
      dir={"rtl"}
      align={"start"}
      style={{ width: "100%" }}
    >
      &nbsp;
      {longestStreak > 1 && (
        <Chip
          text={playedStreakText}
          color={"#DD6B20"}
          icon={FaFireFlameCurved}
          num={longestStreak}
        />
      )}
      {longestWinningStreak > 1 && (
        <Chip
          text={solvedStreakText}
          color={"#D69E2E"}
          icon={FaTrophy}
          num={longestWinningStreak}
        />
      )}
    </Space>
  );
};

const Chip = ({
  text,
  num,
  icon,
  color,
}: {
  text: string;
  num: number;
  icon: IconComponentProps["component"];
  color: string;
}) => (
  <TooltipElement text={text}>
    <Tag
      tabIndex={0}
      aria-label={text}
      style={{
        border: "none",
        borderRadius: "100px",
        backgroundColor: color,
        width: "50px",
        animation: "slidein 1s",
        verticalAlign: "middle",
      }}
    >
      <span
        aria-hidden={true}
        style={{
          margin: "2px",
          fontWeight: 600,
          fontSize: "15px",
          display: "inline-flex",
        }}
      >
        <Icon component={icon} style={{ marginLeft: "3px" }} />
        {num}
      </span>
    </Tag>
  </TooltipElement>
);
